import './Banner.css'
import sevilla1 from './img/sevilla1.jpg'
import sevilla2 from './img/sevilla2.jpg'
import sevilla3 from './img/sevilla3.jpg'
import sevilla4 from './img/sevilla4.jpg'
import { Carousel } from 'react-bootstrap'

let Banner = () => {
    return(
        
        <div className="Banner">
            <Carousel className='w-100 h-100' touch='true'>
                <Carousel.Item interval={3000}>
                    <img className = "bannerImage" src={sevilla1}/>
                </Carousel.Item>
                <Carousel.Item interval={3000}>
                    <img className = "bannerImage" src={sevilla2}/>
                </Carousel.Item>
                <Carousel.Item interval={3000}>
                    <img className = "bannerImage" src={sevilla3}/>
                </Carousel.Item>
                <Carousel.Item interval={3000}>
                    <img className = "bannerImage" src={sevilla4}/>
                </Carousel.Item>
            </Carousel>

    </div>
        
    )
}

export default Banner;